import { defineMessages } from 'react-intl';

export default defineMessages({
    nextDescription: {
        id: 'rewrite.common.views.ml-coverages.Well get required signatures if needed and confirm your rewrite policy next',
        defaultMessage: 'We\'ll get <strong>required signatures</strong>, if needed, and <strong>confirm your rewrite policy</strong> next'
    },
    bind: {
        id: "rewrite.common.config.Binding rewrite",
        defaultMessage: "Binding rewrite"
    },
    bindErrorTitle: {
        id: "rewrite.common.config.Unable to bind rewrite",
        defaultMessage: "Unable to bind rewrite"
    },
    bindErrorMessage: {
        id: "rewrite.common.config.An error occurred while binding the rewrite",
        defaultMessage: "An error occurred while binding the rewrite"
    },
});